import { render } from "./orderPayment.vue?vue&type=template&id=c714aace&scoped=true"
import script from "./orderPayment.vue?vue&type=script&lang=js"
export * from "./orderPayment.vue?vue&type=script&lang=js"

import "./orderPayment.vue?vue&type=style&index=0&id=c714aace&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c714aace"]])

export default __exports__